import { makeStyles, tokens } from '@fluentui/react-components'

export const useThemeSwitcherStyles = makeStyles({
	button: {
		position: 'relative',
		zIndex: '1',
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		padding: '10px 12px',
		backdropFilter: 'blur(20px)',
		borderRadius: '24px',
		border: '2px solid rgba(255, 165, 0, 0.8)',
		transition: 'all 0.3s ease',
		cursor: 'pointer',
		outline: 'none',
		WebkitAppearance: 'none',
		appearance: 'none'
	},
	buttonLight: {
		background: 'rgba(255, 255, 255, 0.9)',
		boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.8)',
		':hover': {
			transform: 'scale(1.05)',
			boxShadow: '0 6px 25px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 1)'
		}
	},
	buttonDark: {
		background: 'rgba(0, 0, 0, 0.8)',
		boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
		':hover': {
			transform: 'scale(1.05)',
			boxShadow: '0 6px 25px rgba(0, 0, 0, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.2)'
		}
	},
	iconSun: {
		fontSize: '18px',
		transition: 'all 0.3s ease'
	},
	iconSunLight: {
		color: '#FF8C00',
		opacity: '1'
	},
	iconSunDark: {
		color: 'rgba(255, 215, 0, 0.7)',
		opacity: '0.6'
	},
	iconMoon: {
		fontSize: '18px',
		transition: 'all 0.3s ease'
	},
	iconMoonLight: {
		color: 'rgba(25, 25, 112, 0.6)',
		opacity: '0.6'
	},
	iconMoonDark: {
		color: '#4169E1',
		opacity: '1'
	}
})

export const useCommonStyles = makeStyles({
	container: {
		padding: '2rem 1rem',
		maxWidth: '1200px',
		margin: '0 auto',
		backgroundColor: tokens.colorNeutralBackground2,
		borderRadius: tokens.borderRadiusMedium
	},
	tabContainer: {
		marginBottom: '2rem'
	},
	tabContent: {
		marginTop: '1rem'
	},
	featureCard: {
		padding: '1.5rem',
		height: '200px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		cursor: 'pointer',
		transition: 'transform 0.2s ease, box-shadow 0.2s ease',
		':hover': {
			transform: 'translateY(-2px)',
			boxShadow: tokens.shadow8
		}
	},
	techBadges: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: '0.5rem',
		justifyContent: 'center',
		marginTop: '1rem'
	},
	sectionCard: {
		marginBottom: '2rem',
		padding: '2rem'
	},
	sectionTitle: {
		marginBottom: '1rem',
		display: 'flex',
		alignItems: 'center'
	},
	sectionIcon: {
		marginRight: '0.5rem',
		color: tokens.colorPaletteBlueBorderActive
	}
})